module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag33_1658AT.1d4bdd25.jpg";